/* eslint-disable @typescript-eslint/naming-convention */

import createSvgIcon from '../Utils/CreateSvgIcon';

export const Lithuania = createSvgIcon(
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_11441_206589)">
      <path
        d="M18.0952 0H1.90476C0.852791 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.852791 16 1.90476 16H18.0952C19.1472 16 20 15.0449 20 13.8667V2.13333C20 0.955126 19.1472 0 18.0952 0Z"
        fill="#006B43"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.6667H20V16.0001H0V10.6667Z"
        fill="#C32427"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H20V5.33333H0V0Z" fill="#FFBA00" />
    </g>
    <defs>
      <clipPath id="clip0_11441_206589">
        <rect width="20" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Lithuania',
  '-2 -4 24 24',
);
